export function isNotEmpty(input) {
  return input !== "";
}

export function isPhoneNumber(input) {
  return /(^\+[0-9]{11}$)|(^[0-9]{10}$)/.test(input);
}
